import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Modal, Select } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

@inject((store: any) => {
    const { authStore, popupStore } = store
    return { authStore, popupStore }
})
@observer
class ChangeAgent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            agentList: [],
            selectedAgent: {}
        }
    }

    componentDidMount() {
        // Do not fetch the agent list before confirming the user is authorized.
        if (this.canChangeAgent()) {
            this.getAgents()
        }
    }

    componentDidUpdate(prevProps) {
        // If roles change while mounted, fetch agents only when authorization
        // flips from false to true and the list has not been loaded yet.
        const prevAllowed = this.canChangeAgent(prevProps)
        const allowed = this.canChangeAgent()
        if (!prevAllowed && allowed && this.state.agentList.length === 0) {
            this.getAgents()
        }
    }

    // Only allow authorized roles to (re)assign agents.
    canChangeAgent = (props = this.props) => {
        // roles can be null (e.g. during logout/re-auth) — guard before .includes.
        const roles = (props.authStore && props.authStore.roles) || []
        return (
            roles.includes('admin') ||
            roles.includes('moderator') ||
            roles.includes('developer') ||
            roles.includes('agents_moderator')
        )
    }

    getAgents = () => {
        users.getAllAgents({ slug: 'agent' }).then(res => {
            this.setState({ agentList: res.data })
        })
    }

    selectAgent = value => {
        let selectedAgent = this.state.agentList.find(({ id }) => id === value)
        this.setState({ selectedAgent })
    }

    openModal = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup('changeAgent')
    }

    onClose = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup(false)
    }

    save = () => {
        const { updateInfo, clientInfo } = this.props
        const { selectedAgent } = this.state

        // Block the mutation if the role changed to an unauthorized one while open.
        if (!this.canChangeAgent()) {
            return
        }

        // Never submit without a valid agent selection.
        if (!selectedAgent || selectedAgent.id == null) {
            return
        }

        let payload = {
            user_id: clientInfo.id,
            currentAgentId: clientInfo.agent_id,
            newAgentId: selectedAgent.id
        }

        users
            .changeAgent(payload)
            .then(() => {
                updateInfo()
                alertPopup({ type: 'success', title: 'העדכון בוצע בהצלחה', body: '' })
                // Reset selection and close modal after a successful update.
                this.setState({ selectedAgent: {} })
                this.onClose()
            })
            .catch(err => {
                const data = (err && err.response && err.response.data) || {}
                if (data.message) {
                    alertPopup({ type: 'error', title: 'העדכון נכשל', body: data.message })
                } else if (data.errors) {
                    alertPopup({
                        type: 'error',
                        title: 'העדכון נכשל',
                        body: (
                            <span>
                                <h6>{`changed: ${JSON.stringify(data.changed)}`}</h6>
                                <h6>{`errors: ${JSON.stringify(data.errors)}`}</h6>
                            </span>
                        )
                    })
                } else {
                    alertPopup({ type: 'error', title: 'העדכון נכשל', body: '' })
                }
            })
    }

    cancel = () => {
        this.onClose()
    }

    render() {
        const { agentList, selectedAgent } = this.state
        const {
            clientInfo,
            popupStore: { popupType }
        } = this.props

        if (!this.canChangeAgent()) {
            return null
        }

        return (
            <div style={{ display: 'flex', marginRight: '10px' }}>
                <>
                    <span onClick={this.openModal} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                        {clientInfo.agent_id ? 'שינוי סוכן' : 'שיוך סוכן'}
                    </span>
                    {popupType === 'changeAgent' && (
                        <Modal
                            onCancel={this.onClose}
                            visible={true}
                            title={
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span>
                                        {`${clientInfo.agent_id ? 'שינוי' : 'שיוך'} סוכן עבור לקוח: ${
                                            clientInfo.first_name
                                        } ${clientInfo.last_name} (${clientInfo.id})`}
                                    </span>
                                    <span style={{ fontSize: '14px', marginTop: '10px' }}>
                                        {`סוכן נוכחי: ${clientInfo.agent_id ? clientInfo.agent_id : 'ללא'}`}
                                    </span>
                                </div>
                            }
                            footer={null}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div>
                                    <h6>{'חיפוש סוכן:'}</h6>
                                    <Select
                                        showSearch
                                        //onSearch={this.searchAgent}
                                        onChange={this.selectAgent}
                                        style={{ width: '60%' }}
                                        defaultValue={'בחר/י סוכן'}
                                        value={selectedAgent.id}
                                        style={{ width: '250px' }}
                                    >
                                        {agentList.map((agent, index) => {
                                            return (
                                                <Select.Option key={index.toString()} value={agent.id}>
                                                    {`${agent.first_name} ${agent.last_name} - ${agent.id}`}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                                <div style={{ alignSelf: 'end' }}>
                                    <Button onClick={this.save} disabled={!selectedAgent || selectedAgent.id == null}>
                                        {'אישור'}
                                    </Button>
                                    <Button onClick={this.cancel}>{'ביטול'}</Button>
                                </div>
                            </div>
                        </Modal>
                    )}
                </>
            </div>
        )
    }
}

export default ChangeAgent
